import React from 'react';
import { FolderOpen, Plus } from 'lucide-react';

export function FilmstripTimeline({ takes, onSelectTake, onAddVariation, thumbnailSrc }) {
  return (
    <footer style={{
      height: '80px',
      borderTop: '1px solid rgba(255,255,255,0.08)',
      background: 'rgba(15, 17, 24, 0.9)',
      backdropFilter: 'blur(12px)',
      display: 'flex',
      alignItems: 'center',
      padding: '0 24px',
      gap: '16px'
    }}>
      <div style={{ fontSize: '12px', fontWeight: 600, color: '#94a3b8', display: 'flex', alignItems: 'center', gap: '6px' }}>
        <FolderOpen size={14} /> Tomas Generadas:
      </div>

      <div style={{ display: 'flex', gap: '12px', overflowX: 'auto', flex: 1, padding: '4px 0' }}>
        {takes.map((take) => (
          <div
            key={take.id}
            onClick={() => onSelectTake(take.id)}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              padding: '6px 12px',
              background: take.active ? 'rgba(168, 85, 247, 0.18)' : '#141724',
              border: take.active ? '1px solid #a855f7' : '1px solid rgba(255,255,255,0.06)',
              borderRadius: '8px',
              cursor: 'pointer',
              fontSize: '12px',
              color: take.active ? '#f8fafc' : '#94a3b8',
              whiteSpace: 'nowrap',
              transition: 'all 0.15s ease'
            }}
          >
            <img src={thumbnailSrc} style={{ width: '32px', height: '32px', borderRadius: '4px', objectFit: 'cover' }} alt="" />
            <span>{take.name}</span>
          </div>
        ))}
      </div>

      <button
        type="button"
        onClick={onAddVariation}
        style={{
          background: 'rgba(255,255,255,0.04)',
          border: '1px solid rgba(255,255,255,0.1)',
          padding: '8px 14px',
          borderRadius: '8px',
          color: '#cbd5e1',
          fontSize: '12px',
          fontWeight: 600,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: '6px',
          transition: 'all 0.15s ease'
        }}
        title="Crear nueva variación de toma"
      >
        <Plus size={14} />
        <span>Nueva Variación</span>
      </button>
    </footer>
  );
}

